import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { ChannelStory, SeeNumbersHint } from "./channels/ChannelStory";

// Section frame with an always-visible header (+ optional story) and a collapsible body.
export const CollapsibleCard = ({
  containerClass = "",
  header,
  story = null,
  children,
  defaultOpen = false,
  testId,
  chevronClass = "text-slate-300",
  hintClass = "text-slate-400",
  outerClass = "relative z-10 mb-8",
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={outerClass} data-testid={testId}>
      <div className={containerClass}>
        <div
          onClick={() => setOpen((v) => !v)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setOpen((v) => !v);
            }
          }}
          role="button"
          tabIndex={0}
          aria-expanded={open}
          data-testid={testId ? `${testId}-toggle` : undefined}
          className="w-full flex items-start gap-3 text-left group cursor-pointer select-none"
        >
          <div className="flex-1 min-w-0">
            {header}
            <ChannelStory story={story} testId={testId ? `${testId}-story` : undefined} />
            {story ? (
              <SeeNumbersHint open={open} className={hintClass} />
            ) : (
              <p className={`${hintClass} text-[11px] mt-1 group-hover:opacity-100 opacity-75 transition-opacity`}>
                {open ? "Click to collapse" : "Click to expand"}
              </p>
            )}
          </div>
          <ChevronDown
            className={`w-6 h-6 ${chevronClass} flex-shrink-0 transition-transform duration-300 mt-1 ${open ? "rotate-180" : ""}`}
          />
        </div>

        <AnimatePresence initial={false}>
          {open && (
            <motion.div
              key="content"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="overflow-hidden"
            >
              <div className="pt-5">{children}</div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
